<div class="card-wrapC">
  <div class="card card-body mt-2">
    <div class="card-headerC mb-3">
      <h2 class="text-size">Change Password</h2>
    </div>
    <div
      class="alert text-center mb-2"
      [ngClass]="alertClass"
      *ngIf="apiResponse"
    >
      {{ alertText }}
      <mat-icon (click)="apiResponse = false">close</mat-icon>
    </div>
    <form [formGroup]="passForm" (ngSubmit)="onSubmit()">
      <div class="field-row row mb-3">
        <div class="col-md-3">
          <label class="label mt-2" for="">Current password</label>
        </div>
        <div class="col-md-7">
          <input
            class="form-control"
            type="password"
            formControlName="currentPassword"
            placeholder="Current Password"
          />
          <mat-error
            *ngIf="
              passForm.get('currentPassword').errors?.required && submitted
            "
            >Required</mat-error
          >
          <mat-error
            *ngIf="
              passForm.get('currentPassword').errors?.minlength && submitted
            "
            >Please enter at least 5 characters</mat-error
          >
        </div>
      </div>
      <div class="field-row row">
        <div class="col-md-3">
          <label class="label mt-2" for="">New password</label>
        </div>
        <div class="col-md-7">
          <input
            class="form-control"
            type="{{ showPassword ? 'text' : 'password' }}"
            formControlName="newPassword"
            placeholder="New Password"
          />
          <mat-error
            *ngIf="passForm.get('newPassword').errors?.required && submitted"
            >Required</mat-error
          >
          <mat-error
            *ngIf="passForm.get('newPassword').errors?.minlength && submitted"
            >Please enter at least 5 characters</mat-error
          >
        </div>
      </div>
      <div class="field-row row mt-2">
        <div class="col-md-3"></div>
        <div class="col-md-7">
          <mat-checkbox (click)="showPassword = !showPassword"
            >Show Password</mat-checkbox
          >
        </div>
      </div>
      <div class="field-row row mt-3">
        <div class="col-md-3"></div>
        <div class="col-md-7 d-flex justify-content-between">
          <button
            mat-stroked-button
            color="primary"
            class="me-4"
            type="button"
            (click)="backLink()"
          >
            Cancel
          </button>
          <button mat-flat-button color="primary" type="submit">Update</button>
        </div>
      </div>
    </form>
  </div>
</div>